export default __webpack_public_path__ + "static/media/telegram-icon-black.6b5bdf6a.svg";